/* The Lab NA — contact hero response timer
   Updates all .lab-cta-timer elements based on Eastern Time business hours. */

(function() {
  'use strict';

  function updateTimers() {
    var now = new Date();
    var etStr = now.toLocaleString('en-US', { timeZone: 'America/New_York' });
    var et = new Date(etStr);
    var day = et.getDay();
    var hours = et.getHours();
    var isWeekday = day >= 1 && day <= 5;
    var isOpen = isWeekday && hours >= 9 && hours < 17;

    document.querySelectorAll('.lab-cta-timer').forEach(function(timer) {
      var textEl = timer.querySelector('.lab-cta-timer-text');
      if (!textEl) return;

      if (isOpen) {
        timer.classList.add('lab-cta-online');
        timer.classList.remove('lab-cta-offline');
        textEl.innerHTML = 'Avg. response <strong>~15 min</strong>';
      } else {
        timer.classList.add('lab-cta-offline');
        timer.classList.remove('lab-cta-online');

        var next = new Date(et);
        next.setHours(9, 0, 0, 0);

        if (isWeekday && hours >= 17) {
          next.setDate(next.getDate() + 1);
        } else if (!(isWeekday && hours < 9)) {
          next.setDate(next.getDate() + 1);
        }

        while (next.getDay() === 0 || next.getDay() === 6) {
          next.setDate(next.getDate() + 1);
        }

        var diff = next - et;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        textEl.innerHTML = h > 0
          ? 'Opens in <strong>' + h + 'h ' + m + 'm</strong>'
          : 'Opens in <strong>' + m + 'm</strong>';
      }
    });
  }

  updateTimers();
  setInterval(updateTimers, 30000);
})();
